import type { TypeEventPatch, TypeOccurrenceChange } from '@/types/calendar/types.calendar.input';

const STRING_FIELDS = ['title', 'color', 'description', 'place', 'projectId', 'taskId'] as const;

export function eventPatchBody<T extends TypeEventPatch | TypeOccurrenceChange>(patch: T): Record<string, unknown> {
    const body: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(patch)) {
        if (value === undefined) continue;
        body[key] = value === null && (STRING_FIELDS as readonly string[]).includes(key) ? '' : value;
    }
    return body;
}

export default eventPatchBody;
